import { OrganizationCode } from 'merchandising-sdk';

export const environment = {
  production: false,
  organization: OrganizationCode.GMI,
  is_online: true,
  assets_url: 'https://stmerchandisinggmi.blob.core.windows.net/gmi-assets',
  local_db_name: '',
  azure_blob_sas_url: ``,
  azure_container: ``
};